import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "prismjs/themes/prism-twilight.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";
import Prism from "prismjs";

global.Prism = Prism;

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js